import { render, staticRenderFns } from "./CtaButton.vue?vue&type=template&id=f0be7acc&"
import script from "./CtaButton.ts?vue&type=script&lang=ts&"
export * from "./CtaButton.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports